<template>
  <div>
    <div class="check-center">
      <p class="check-text">BOOK A NEW SHIPMENT</p>
      <ByForm :rules="rules" :model="formData" ref="ruleForm">
        <div class="check-form_flex check-form__group">
          <ByFormItem
            style="width: 380px"
            prop="from"
            required
            class="check-form-item"
          >
            <PickUpCity
              :provinceAndCity="provinceAndCity"
              v-model="formData.fromLabel"
              @select="
                (item) => {
                  formData.fromItems = item;
                  formData.from = formData.fromLabel;
                }
              "
            >
              <template slot="prefix">
                <svg-icon size="20" name="juxing1"></svg-icon>
                <span>*Pick up city ：</span>
              </template>
              <template v-if="item" slot-scope="{ item }">
                <span style="margin-left: 90px" class="name">{{
                  item.label
                }}</span>
              </template>
            </PickUpCity>
          </ByFormItem>
          <ByFormItem
            style="width: 380px"
            prop="end"
            required
            class="check-form-item"
          >
            <PickUpCity
              :provinceAndCity="provinceAndCity"
              v-model="formData.endLabel"
              @select="
                (item) => {
                  formData.toItems = item;
                  formData.end = formData.endLabel;
                }
              "
            >
              <template slot="prefix">
                <svg-icon size="20" name="juxing1"></svg-icon>
                <span>*Delivery city ：</span>
              </template>
              <template v-if="item" slot-scope="{ item }">
                <span style="margin-left: 90px" class="name">{{
                  item.label
                }}</span>
              </template>
            </PickUpCity>
          </ByFormItem>

          <ByFormItem
            style="flex: 1"
            prop="from"
            required
            class="check-form-item"
          >
            <CheckCalender v-model="formData.dateVal" style="flex: 1">
              <template slot="prefix">
                <span>*Time of appointment :</span>
              </template>
              <template slot="custom_suffix">
                <svg-icon name="xingzhuang34"></svg-icon>
              </template>
            </CheckCalender>
          </ByFormItem>
        </div>

        <div class="check-form_flex check-form__group">
          <ByFormItem prop="from" required class="check-form-item">
            <CheckFrame class="check-units">
              <template slot="prefix">
                <svg-icon size="20" name="juxing1"></svg-icon>
                <span>*Shipment units :</span>
              </template>
              <template slot="custom_suffix">
                <ByRadio v-model="formData.units" label="0">KG/CBM</ByRadio>
                <ByRadio v-model="formData.units" label="1">LB/CFT</ByRadio>
              </template>
            </CheckFrame>
          </ByFormItem>
          <ByFormItem prop="weight" required class="check-form-item">
            <CheckInput
              style="width: 263px"
              v-model="formData.weight"
              type='float'
              placeholder="Total Weight"
            >
              <template slot="prefix">
                <svg-icon size="20" name="home_ic_weight"></svg-icon>
              </template>
              <template slot="suffix"> KG </template>
            </CheckInput>
          </ByFormItem>

          <ByFormItem class="check-form-item">
            <CheckInput
              style="width: 290px"
              v-model="formData.volume"
              placeholder="Total Volume"
              type='float'
            >
              <template slot="prefix">
                <svg-icon size="20" name="home_ic_volume"></svg-icon>
              </template>
              <template slot="suffix"> CBM </template>
            </CheckInput>
          </ByFormItem>
          <ByFormItem style="flex: 1" class="check-form-item">
            <by-button
              :class="['check__button', { 'button-active': buttonActive }]"
              @click="goCheck"
              >ENQUIRY</by-button
            >
          </ByFormItem>
        </div>
      </ByForm>
    </div>
  </div>
</template>
  
  <script>
import { post, fetch } from "@/ask/axios";
import PickUpCity from "./components/PickUpCity.vue";
import CheckInput from "./components/CheckInput.vue";
import CheckFrame from "./components/CheckFrame.vue";
import CheckCalender from "./components/CheckCalender.vue";
import ByRadio from "@/components/public/ByRadio.vue";
import ByForm from "./components/ByForm.vue";
import ByFormItem from "./components/ByFormItem.vue";
export default {
  name: "PickUp",
  components: {
    PickUpCity,
    CheckInput,
    CheckFrame,
    ByRadio,
    CheckCalender,
    ByForm,
    ByFormItem,
  },
  data() {
    return {
      formData: {
        from: "",
        fromLabel: "",
        end: "",
        endLabel: "",
        unitType: "CTNS",
        volume: "",
        units: "0",
        weight: "",
        dateVal: new Date().Format("yyyy-M-d"),
      },
      startAirDatas: [],
      endAirDatas: [],
      provinceAndCity: {
        hotCity: [],
        allCity: [],
      },
      rules: {
        from: { required: true },
        end: { required: true },
        weight: { required: true },
      },
      buttonActive: false,
    };
  },
  watch: {
    formData: {
      handler(val) {
        // console.log("====88888",this.formData);
        // if(val.fromItems.City_NameEn != "AoMenTeBieXingZhengQu"){
        //   console.log("====8888",this.formData);
        //   this.formData.toItems = []
        // }
        // delete val.volumetoItems
        // val.forEach((v,k)=>{
        for (let k in val) {
          if (this.rules.hasOwnProperty(k)) {
            if (!val[k]) {
              this.buttonActive = false;
              return;
            }
          }
        }

        // })
        this.buttonActive = true;
      },
      deep: true,
    },
  },
  mounted() {
    this.getThHotCityApi();
    this.getProvDataApi();
  },
  methods: {
    //调用弹窗去查价
    goCheck() {
      //console.log("🚀 ~ goCheck");
      this.$refs["ruleForm"].validate((valid) => {
        //console.log("🚀 ~ valid", valid);

        // if (typeof(valid)==='string') {
        //    return  this.$refs[valid].focus()

        // }
        if (typeof valid === "string") return alert("invalid");
        //   this.addField();
        this.$emit("checkBtn", this.formData, "pickUp");
      });

      //   this.addField();
      // debugger;
    },

    //常用市区接口
    getThHotCityApi() {
      // const url = this.$api01 + "/api/InfoCustomer/Attribute/QueryThHotCity";
      const url = this.$api04 + "/Basics/api/Attribute/QueryThHotCity";
      fetch(url).then((res) => {
        //console.log("🚀 ~ res", res);
        this.provinceAndCity.hotCity = this.dataPaging(res.Results);
      });
    },

    //省市区接口
    getProvDataApi() {
      const url =
        // this.$api02 + "/api/EbayCustomer/Province/QueryProvinceAndCity";
        this.$api04 + "/Basics/api/SysRegion/QueryAllProvinceAndCity";
      fetch(url).then(({ Results }) => {
        //console.log("🚀 ~ Results", Results);
        let res = { Results: Results };
        let allCityList = [];
        for (let i = 0; i < res.Results.length; i++) {
          let cityList = res.Results[i]["CityList"];
          let province = res.Results[i]["Province"];
          
          for (let j = 0; j < cityList.length; j++) {
            this.$set(cityList[j], "Id", cityList[j]["City_Key"]);
            let areaList = cityList[j].AreaList;
            // 城市
            allCityList.push({
              ...cityList[j],
              Province_Key: province.Province_Key,
              Province_NameCh: province.Province_NameCh,
              Province_NameEn: province.Province_NameEn,
              Regionalization_Code: province.Regionalization_Code,
              
            });
            for (let n = 0; n < areaList.length; n++) {
              this.$set(areaList[n], "Id", areaList[n]["CityArea_Key"]);
            }
          }
          for (let j = 0; j < province.length; j++) {
            this.$set(province[j], "Id", province[j]["Province_Key"]);
          }
        }
        Results.forEach((p, index) => {
          p["Province"]["CityList"] = p["CityList"];
          Results[index] = p["Province"];
        });
        this.provinceAndCity.province = this.dataPaging(Results);
        console.log(allCityList, 'allCityList');
        this.provinceAndCity.allCity = allCityList;
      });
    },
    //数据分页
    dataPaging(data) {
      let arrs = [[]];
      let page = 0;

      for (let i = 0; i < data.length; i++) {
        if ((i + 1) % 19 === 0) {
          page++;
          arrs[page] = [];
        }
        arrs[page].push(data[i]);
      }
      return arrs;
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.check-units {
  width: 380px;
  flex: none !important;
}
// .check-center /deep/ .by-button {
//   flex: 1 !important;
//   // width: 320px;1
//   background-color: #96aedc;
//   color: #004fb1;
// // }
// .check-center .check__button{
//   background: #96aedc;
//   transition: all .2s ease-in-out;
// }
.check__button.button-active {
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/reception/checkPrice/PickUp.vue